import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SuccsessMsgModal from "../../components/SuccessMsgModal";

function AddComments({ show, onClose, rfqId }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm();

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [bugId, setBugId] = useState("");
  const [lastComments, setLastComment] = useState(null);

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.ADD_COMMENTS
  );

  const { data: lastComment, postData: getComment } = usePostRequest(
    API_ENDPOINTS.GET_LAST_COMMENT
  );

  // useEffect(() => {
  //   getComment({
  //     auto_id: bugId,
  //   });
  // }, [bugId]);

  const onSubmit = async (formData) => {
    try {
      const payload = {
        auto_id: bugId,
        comment: formData?.description || null,
      };

      console.log("✅ Final Payload to submit:", payload);

      createORDER(payload, onSuccess, onError, API_ENDPOINTS.ADD_COMMENTS);
      reset();
      onClose();
      handleClose();
    } catch (err) {
      toast.error("Failed to add comments, please try again.");
    }
  };

  const onSuccess = (res) => {
    setIsModalOpen({
      show: true,
      title: "Comment Added Successfully!",
      message: `Added by ${user?.username}. Added on ${moment(
        new Date()
      ).format("MM/DD/YYYY")}.`,
      btntext: "Return Home",
    });
  };

  useEffect(() => {
    if (window.location.search && show) {
      const autoId = window.location.search.slice(1);
      setBugId(autoId);
      getComment({
        auto_id: autoId,
      });
    }
  }, [window.location.search]);

  useEffect(() => {
    if (lastComment?.data?.comment) {
      setLastComment(lastComment.data.comment);
    } else {
      // setLastComment("No comments added");
      setLastComment("");
    }
  }, [lastComment]);

  const handleClose = () => {
    const newUrl = window.location.pathname;
    window.history.replaceState(null, "", newUrl);
    onClose();
    setLastComment("");
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="justify-content-center d-block" closeButton>
          <Modal.Title className="tittle_deal mb-0">Bug Comments:</Modal.Title>
          <span style={{ color: "#066fd1" }} className="">
            {lastComments}
          </span>
        </Modal.Header>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label className="">Comments</Form.Label>
              <InputGroup>
                <Form.Control
                  as="textarea"
                  name="Enter description"
                  {...register("description")}
                  style={{
                    height: "auto",
                    minHeight: "90px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  placeholder="Enter comments"
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-end">
            <Button variant="warning" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
            <Button variant="outline-secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default AddComments;
